import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Form, Grid, Button } from 'semantic-ui-react';
import { reduxForm, Field } from 'redux-form';
import moment from 'moment';
import { set } from 'lodash';

import {
  EditDailyDepositFieldEnum as Fields,
  EditDailyDepositInfoFieldEnum,
} from 'Common/FieldEnum';
import { EDIT_DAILY_DEPOSIT_FORM_NAME } from 'Common/FormEnum';
import {
  EditDailyDepositTabOptions,
  EditDailyDepositTabEnum,
} from '../helpers/EditDailyDepositHelpers';
import { DailyDepositSalesTable } from './sales/DailyDepositSalesTable';
import { DailyDepositAccrualsTable } from './AccrualsTable';
import { DailyDepositSummaryForm } from './SummaryForm';
import { DatePickerField } from 'Common/SemanticWrapper';
import {
  setExists,
  clearExists,
} from './../state/modifydailydepositgrid/actions';
import { createToast, toastType } from 'Common/ToastHelper';
import { SiteComponent } from 'Common/SiteComponent';

class EditDailyDepositFormContainer extends Component {
  getSecondarySites = () => {
    const { formValues, sites } = this.props;

    return !formValues ||
      !formValues[Fields.Info] ||
      !formValues[Fields.Info][EditDailyDepositInfoFieldEnum.PrimarySiteId]
      ? []
      : sites.find(
          site =>
            site.Id ===
            formValues[Fields.Info][EditDailyDepositInfoFieldEnum.PrimarySiteId]
        ).SecondarySites;
  };

  componentDidUpdate(prevProps) {
    const { formValues, change } = this.props;

    if (formValues && prevProps.formValues) {
      const prefix = `${Fields.Info}.`;
      const info = formValues[Fields.Info];
      const prevInfo = prevProps.formValues[Fields.Info];

      if (
        info &&
        prevInfo &&
        info[EditDailyDepositInfoFieldEnum.PrimarySiteId] !==
          prevInfo[EditDailyDepositInfoFieldEnum.PrimarySiteId]
      ) {
        const secondarySites = this.getSecondarySites();
        if (secondarySites.length === 1) {
          change(
            `${prefix}${EditDailyDepositInfoFieldEnum.SiteId}`,
            secondarySites[0].Id
          );
        } else {
          change(`${prefix}${EditDailyDepositInfoFieldEnum.SiteId}`, null);
        }
      }

      if (
        info &&
        prevInfo &&
        info[EditDailyDepositInfoFieldEnum.ClosingDate] &&
        info[EditDailyDepositInfoFieldEnum.SiteId] &&
        (info[EditDailyDepositInfoFieldEnum.ClosingDate] !==
          prevInfo[EditDailyDepositInfoFieldEnum.ClosingDate] ||
          info[EditDailyDepositInfoFieldEnum.SiteId] !==
            prevInfo[EditDailyDepositInfoFieldEnum.SiteId])
      ) {
        this.props.setExists({
          site: info[EditDailyDepositInfoFieldEnum.SiteId],
          fromDate: info[EditDailyDepositInfoFieldEnum.ClosingDate],
          toDate: info[EditDailyDepositInfoFieldEnum.ClosingDate],
          isSupper: this.props.isSupper,
        });
      }

      if (this.props.exists) {
        createToast(
          toastType.error,
          'Error',
          `Daily Deposit already exists for Serving Site ${
            info[EditDailyDepositInfoFieldEnum.SiteId]
          } on ${info[EditDailyDepositInfoFieldEnum.ClosingDate]}.`
        );

        if (
          info[EditDailyDepositInfoFieldEnum.PrimarySiteId] ===
          info[EditDailyDepositInfoFieldEnum.SiteId]
        ) {
          change(
            `${prefix}${EditDailyDepositInfoFieldEnum.PrimarySiteId}`,
            null
          );
        } else {
          change(`${prefix}${EditDailyDepositInfoFieldEnum.SiteId}`, null);
        }

        this.props.clearExists();
      }
    }
  }

  render() {
    const {
      formValues,
      change,
      isSupper,
      isReadOnly,
      sites,
      isNew,
      handleSubmit,
      tab,
      onTabChange,
    } = this.props;

    const disabled =
      !formValues ||
      !formValues[Fields.Info] ||
      !formValues[Fields.Info][EditDailyDepositInfoFieldEnum.SiteId] ||
      !formValues[Fields.Info][EditDailyDepositInfoFieldEnum.PrimarySiteId] ||
      !formValues[Fields.Info][EditDailyDepositInfoFieldEnum.ClosingDate];

    const secondarySiteOptions = this.getSecondarySites();
    return (
      <Fragment>
        <Form onSubmit={handleSubmit}>
          <Grid>
            <Grid.Row columns={3}>
              <Grid.Column>
                <Field
                  label={'Date'}
                  component={DatePickerField}
                  name={`${Fields.Info}.${
                    EditDailyDepositInfoFieldEnum.ClosingDate
                  }`}
                  openToDate={moment()}
                  maxDate={moment()}
                  disabled={!isNew}
                />
              </Grid.Column>
              <Grid.Column>
                <SiteComponent
                  siteOptions={sites}
                  label={'Serving Site'}
                  isForm={true}
                  name={`${Fields.Info}.${
                    EditDailyDepositInfoFieldEnum.PrimarySiteId
                  }`}
                  isAllRequired={false}
                  disabled={!isNew}
                />
              </Grid.Column>
              <Grid.Column>
                <SiteComponent
                  label={'Site'}
                  isForm={true}
                  siteOptions={secondarySiteOptions}
                  name={`${Fields.Info}.${
                    EditDailyDepositInfoFieldEnum.SiteId
                  }`}
                  isAllRequired={false}
                  disabled={secondarySiteOptions.length === 0 || !isNew}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              {formValues &&
                formValues[Fields.Info] &&
                (formValues[Fields.Info][
                  EditDailyDepositInfoFieldEnum.SiteId
                ] ? (
                  <Grid.Column>
                    <Button.Group basic className={`btn-group--active-group`}>
                      {EditDailyDepositTabOptions.map((option, i) => {
                        return (
                          <Button
                            basic
                            active={tab === option.value}
                            className="white"
                            disabled={option.disabled || disabled}
                            key={i}
                            onClick={e => {
                              e.preventDefault();
                              onTabChange(option.value);
                            }}
                          >
                            {option.label}
                          </Button>
                        );
                      })}
                    </Button.Group>
                  </Grid.Column>
                ) : (
                  <Grid.Column />
                ))}
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                {formValues &&
                  (tab === EditDailyDepositTabEnum.Sales ? (
                    <DailyDepositSalesTable
                      formValues={formValues ? formValues : {}}
                      change={change}
                      isSupper={isSupper}
                      disabled={disabled || isReadOnly}
                    />
                  ) : tab === EditDailyDepositTabEnum.Accruals ? (
                    <DailyDepositAccrualsTable
                      formValues={formValues ? formValues : {}}
                      isSupper={isSupper}
                      change={change}
                      disabled={disabled || isReadOnly}
                    />
                  ) : (
                    <DailyDepositSummaryForm
                      isSupper={isSupper}
                      formValues={formValues ? formValues : {}}
                      change={change}
                      disabled={disabled || isReadOnly}
                    />
                  ))}
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Form>
      </Fragment>
    );
  }
}

const validate = values => {
  var errors = {};
  if (
    !values[Fields.Info] ||
    !values[Fields.Info][EditDailyDepositInfoFieldEnum.SiteId]
  ) {
    set(
      errors,
      `${Fields.Info}.${EditDailyDepositInfoFieldEnum.SiteId}`,
      'Site must be set.'
    );
  }

  if (
    !values[Fields.Info] ||
    !values[Fields.Info][EditDailyDepositInfoFieldEnum.PrimarySiteId]
  ) {
    set(
      errors,
      `${Fields.Info}.${EditDailyDepositInfoFieldEnum.PrimarySiteId}`,
      'Serving site must be set.'
    );
  }

  if (
    !values[Fields.Info] ||
    !values[Fields.Info][EditDailyDepositInfoFieldEnum.ClosingDate]
  ) {
    set(
      errors,
      `${Fields.Info}.${EditDailyDepositInfoFieldEnum.ClosingDate}`,
      'Date must be set.'
    );
  }

  return errors;
};

const mapStateToProps = state => {
  const { ModifyDailyDepositGrid } = state.ModifyDailyDepositState;
  return {
    exists: ModifyDailyDepositGrid.exists,
  };
};

const EditDailyDepositForm = reduxForm({
  form: EDIT_DAILY_DEPOSIT_FORM_NAME,
  enableReinitialize: true,
  validate,
})(
  withRouter(
    connect(
      mapStateToProps,
      {
        setExists,
        clearExists,
      }
    )(EditDailyDepositFormContainer)
  )
);

export { EditDailyDepositForm };



// WEBPACK FOOTER //
// ./src/pages/modifydailydeposits/components/EditDailyDepositForm.js